// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../Assets/images/accueil-contact-matching-plat.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-section {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-color: #F9F9F6;
  background-repeat: no-repeat;
  padding: 8% 20%;
}


.button-submit {
  background-color: #8d7268;
  color: white;
}

.mt-5-margin {
  margin-top: 15% !important;
}

@media (min-width: 1090px) {
  .bg-section-mobile {
    display: none;
  }
  .adjust-form-class {
    margin-right: 50px;
    margin-left: 50px;
    margin-bottom: 50px;
  }
  .class-col-boudoir {
    /*background-color: #8D7268;*/
    background-color: #4AAE9B;
    border-radius: 20px;
    margin-top: -6%;
    margin-bottom: -65px;
    margin-left: -30px;
    background-repeat: no-repeat;
    background-size: contain;
    padding-left: 30px; 
    background-position: center;
  }
  .adjust-coordonnes-class {
    margin: 30% 0px;
    /*transform: translate(0, 19%);*/
  }
  .class-row {
    display: flex;
  }

  .contact-form {
    background-color: white;
    border-radius: 20px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    box-shadow: 0 4px 20px 0 rgb(0, 0, 0, 25%);
  }
}
@media (max-width: 1089px) {
  .bg-section-mobile {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    padding: 20% 15%;
    background-position: bottom;
  }
  .adjust-form-class {
    margin-right: 50px;
    margin-bottom: 80px;
  }

  .bg-section {
    display: none;
  }
  .class-col-boudoir {
    background-color: #4AAE9B;
    border-radius: 20px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: right;
  }
  .adjust-coordonnes-class {
    margin: 50% 0px;
  }
  .contact-form {
    border-radius: 20px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    padding: 20px;
    margin-bottom: 50px;
    box-shadow: 0 4px 20px 0 rgb(0, 0, 0, 25%);
  }
}

/* Add these styles in your CSS file */
.custom-input::placeholder {
  font-size: 14px; /* Default for smaller screens */
}

/* Adjust font size for larger screens */
@media (min-width: 576px) { /* Small screens */
  .custom-input::placeholder {
    font-size: 12px;
  }
}

@media (min-width: 768px) { /* Medium screens */
  .custom-input::placeholder {
    font-size: 12px;
  }
}

@media (min-width: 992px) { /* Large screens */
  .custom-input::placeholder {
    font-size: 12px;
  }
}

@media (min-width: 1240px) { /* Extra-large screens */
  .custom-input::placeholder {
    font-size: 14px;
  }
}

/* Add this to your CSS file */
.responsive-select {
  font-size: 12px; /* Default font size for small screens */
}

@media (min-width: 768px) { /* Medium screens */
  .responsive-select {
    font-size: 12px !important;
  }
}

@media (min-width: 992px) { /* Large screens */
  .responsive-select {
    font-size: 12px !important;
  }
}
  @media (min-width: 1240px) { /* Large screens */
    .responsive-select {
      font-size: 14px !important;
    }
}

`, "",{"version":3,"sources":["webpack://./src/Pages/Home/Pages/Contact/ContactForm.css"],"names":[],"mappings":"AAAA;EACE,yDAAkF;EAClF,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;AACjB;;;AAGA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,6BAA6B;IAC7B,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,4BAA4B;IAC5B,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;EAC7B;EACA;IACE,eAAe;IACf,gCAAgC;EAClC;EACA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;IAC5B,wBAAwB;IACxB,2BAA2B;IAC3B,0CAA0C;EAC5C;AACF;AACA;EACE;IACE,yDAAkF;IAClF,4BAA4B;IAC5B,gBAAgB;IAChB,2BAA2B;EAC7B;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,4BAA4B;IAC5B,wBAAwB;IACxB,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;EAC5C;AACF;;AAEA,sCAAsC;AACtC;EACE,eAAe,EAAE,gCAAgC;AACnD;;AAEA,wCAAwC;AACxC,4BAA4B,kBAAkB;EAC5C;IACE,eAAe;EACjB;AACF;;AAEA,4BAA4B,mBAAmB;EAC7C;IACE,eAAe;EACjB;AACF;;AAEA,4BAA4B,kBAAkB;EAC5C;IACE,eAAe;EACjB;AACF;;AAEA,6BAA6B,wBAAwB;EACnD;IACE,eAAe;EACjB;AACF;;AAEA,8BAA8B;AAC9B;EACE,eAAe,EAAE,wCAAwC;AAC3D;;AAEA,4BAA4B,mBAAmB;EAC7C;IACE,0BAA0B;EAC5B;AACF;;AAEA,4BAA4B,kBAAkB;EAC5C;IACE,0BAA0B;EAC5B;AACF;EACE,6BAA6B,kBAAkB;IAC7C;MACE,0BAA0B;IAC5B;AACJ","sourcesContent":[".bg-section {\n  background-image: url(../../../../Assets/images/accueil-contact-matching-plat.png);\n  background-color: #F9F9F6;\n  background-repeat: no-repeat;\n  padding: 8% 20%;\n}\n\n\n.button-submit {\n  background-color: #8d7268;\n  color: white;\n}\n\n.mt-5-margin {\n  margin-top: 15% !important;\n}\n\n@media (min-width: 1090px) {\n  .bg-section-mobile {\n    display: none;\n  }\n  .adjust-form-class {\n    margin-right: 50px;\n    margin-left: 50px;\n    margin-bottom: 50px;\n  }\n  .class-col-boudoir {\n    /*background-color: #8D7268;*/\n    background-color: #4AAE9B;\n    border-radius: 20px;\n    margin-top: -6%;\n    margin-bottom: -65px;\n    margin-left: -30px;\n    background-repeat: no-repeat;\n    background-size: contain;\n    padding-left: 30px; \n    background-position: center;\n  }\n  .adjust-coordonnes-class {\n    margin: 30% 0px;\n    /*transform: translate(0, 19%);*/\n  }\n  .class-row {\n    display: flex;\n  }\n\n  .contact-form {\n    background-color: white;\n    border-radius: 20px;\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center;\n    box-shadow: 0 4px 20px 0 rgb(0, 0, 0, 25%);\n  }\n}\n@media (max-width: 1089px) {\n  .bg-section-mobile {\n    background-image: url(../../../../Assets/images/accueil-contact-matching-plat.png);\n    background-repeat: no-repeat;\n    padding: 20% 15%;\n    background-position: bottom;\n  }\n  .adjust-form-class {\n    margin-right: 50px;\n    margin-bottom: 80px;\n  }\n\n  .bg-section {\n    display: none;\n  }\n  .class-col-boudoir {\n    background-color: #4AAE9B;\n    border-radius: 20px;\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: right;\n  }\n  .adjust-coordonnes-class {\n    margin: 50% 0px;\n  }\n  .contact-form {\n    border-radius: 20px;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n    padding: 20px;\n    margin-bottom: 50px;\n    box-shadow: 0 4px 20px 0 rgb(0, 0, 0, 25%);\n  }\n}\n\n/* Add these styles in your CSS file */\n.custom-input::placeholder {\n  font-size: 14px; /* Default for smaller screens */\n}\n\n/* Adjust font size for larger screens */\n@media (min-width: 576px) { /* Small screens */\n  .custom-input::placeholder {\n    font-size: 12px;\n  }\n}\n\n@media (min-width: 768px) { /* Medium screens */\n  .custom-input::placeholder {\n    font-size: 12px;\n  }\n}\n\n@media (min-width: 992px) { /* Large screens */\n  .custom-input::placeholder {\n    font-size: 12px;\n  }\n}\n\n@media (min-width: 1240px) { /* Extra-large screens */\n  .custom-input::placeholder {\n    font-size: 14px;\n  }\n}\n\n/* Add this to your CSS file */\n.responsive-select {\n  font-size: 12px; /* Default font size for small screens */\n}\n\n@media (min-width: 768px) { /* Medium screens */\n  .responsive-select {\n    font-size: 12px !important;\n  }\n}\n\n@media (min-width: 992px) { /* Large screens */\n  .responsive-select {\n    font-size: 12px !important;\n  }\n}\n  @media (min-width: 1240px) { /* Large screens */\n    .responsive-select {\n      font-size: 14px !important;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
